// removed by extract-text-webpack-plugin
module.exports = {"root":"_2dEtb5I"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Accessibility/ScreenReaderSkipLink.less
 ** module id = 716
 ** module chunks = 0
 **/